import { getWidgetData } from '@/services/widgetService'

export default {
    data () {
        return {
            abortController: new AbortController()
        }
    },
    computed: {
        requestConfig () {
            return {
                signal: this.abortController.signal
            }
        }
    },
    methods: {
        async loadWidgetData (data, _config = {}) {
            const config = {
                ..._config,
                ...this.requestConfig
            }
            return getWidgetData(data, config)
        }
    },
    beforeDestroy () {
        this.abortController.abort()
    }
}
